'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
var loader = require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var shimmerLoader = require('../../../../styles/styled-components/shimmer-loader.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
var baseLoader = require('../base-loader/base-loader.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseShimmerLoader = ({ className , look , numLines , ...otherProps })=>{
    const posNumLines = numLines > 0 ? numLines : 1;
    const shimmerLines = [];
    for(let i = 0; i < posNumLines; i++){
        shimmerLines.push(/*#__PURE__*/ React__default.default.createElement("span", {
            key: `shimmer-br-${i}`,
            className: "bf-loader__shimmer--br"
        }));
    }
    return /*#__PURE__*/ React__default.default.createElement(baseLoader.BaseLoader, _extends({
        className: classnames__default.default({
            'bf-loader__shimmer': true,
            'bf-loader__shimmer--default': look === loader.ShimmerLoaderLooks.Default,
            [`${className}`]: !!className
        })
    }, otherProps), shimmerLines);
};
const shimmer = styled.keyframes`
  0% {
    background-position: -100% 0;
  }
  100% {
    background-position: 100% 0;
  }
`;
const Loader = styled__default.default(BaseShimmerLoader)`
  .bf-loader__shimmer--br {
    ${({ look  })=>shimmerLoader.getShimmerLoaderTheme({
        look
    })}
    animation: ${shimmer} 2s infinite;
    animation-timing-function: linear;
    background-size: calc(100% + 1000px) 100%;
    border-radius: 6px;
    display: flex;
    width: 175px;
    height: 12px;
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
const ShimmerLoader = (props)=>{
    const { look =loader.ShimmerLoaderLooks.Default , numLines =1  } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Loader, _extends({}, props, {
        look: look,
        numLines: numLines
    })));
};

exports.ShimmerLoader = ShimmerLoader;
//# sourceMappingURL=shimmer-loader.js.map
